import { render, staticRenderFns } from "./bigNumber.vue?vue&type=template&id=74a0b4aa&scoped=true"
import script from "./bigNumber.vue?vue&type=script&lang=js"
export * from "./bigNumber.vue?vue&type=script&lang=js"
import style0 from "./bigNumber.vue?vue&type=style&index=0&id=74a0b4aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a0b4aa",
  null
  
)

export default component.exports